// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Photo40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Photo40: FC<Photo40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
            viewBox="0 0 40 40"
        >
            <path d="M7.778 35q-1.125 0-1.952-.826-.825-.827-.826-1.952V7.778q0-1.125.826-1.952.827-.825 1.952-.826h24.444q1.124 0 1.952.826.826.827.826 1.952v24.444q0 1.124-.826 1.952-.827.826-1.952.826zm0-2.778h24.444V7.778H7.778zm2.11-3.805h20.25l-6.166-8.222-5.333 6.972-3.834-5.195z" />
        </svg>
    );
};

export default Photo40;
